
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/2784b1087cb7036f7baf2efd55c38b07.jpg"
                alt="ECOMODE STUDIO VPN Development"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-2xl -z-10"></div>
          </div>

          <div className="space-y-6">
            <h4 className="text-blue-600 font-semibold text-lg">
              <a href="#about">About ECOMODE STUDIO</a>
            </h4>
            <h3 className="text-4xl lg:text-5xl font-bold text-gray-900">
              Innovating Digital Security Solutions
            </h3>
            <p className="text-lg text-gray-600 leading-relaxed">
              ECOMODE STUDIO DOO is a forward-thinking technology company based in Kikinda, Serbia, dedicated to developing cutting-edge applications that enhance digital security and user privacy. Our flagship VPN solution represents our commitment to protecting users' online freedom and privacy in an increasingly connected world.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              We believe that everyone deserves secure, private, and unrestricted access to the internet. Our team of experienced developers and security experts work tirelessly to create innovative solutions that combine robust security features with user-friendly interfaces, ensuring that digital privacy is accessible to all.
            </p>

            <div className="grid grid-cols-2 gap-6 pt-6">
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-blue-600 text-xl"></i>
                  <strong className="text-gray-900">Location</strong>
                </div>
                <p className="text-gray-600">Kikinda, Serbia</p>
              </div>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <i className="ri-focus-3-line text-blue-600 text-xl"></i>
                  <strong className="text-gray-900">Focus</strong>
                </div>
                <p className="text-gray-600">VPN &amp; Security Apps</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
